import React from 'react';
import { history } from 'store/configureStore';
import { useSelector, useDispatch } from 'react-redux';
import SortTable from 'components/parts/item/sortTable';
import File from 'components/srv/file/file';
import { getProgramFiles } from 'actions/programFileAction';
import { clearMessage, setMessage } from 'actions/messageAction';
import { setLoading, clearLoading } from 'actions/loadingAction';
import { Auth } from 'aws-amplify';
import { consoleLogger } from 'helpers';
import { lang } from 'lang';

/**
 * プログラムファイル一覧をテーブルで表示するコンポーネント
 */
const FileList = () => {
  const dispatch = useDispatch();
  const { msg, error } = lang;
  // グローバルステートからプログラムファイルを取り出す
  const filesState = useSelector((state) => state.programFile);
  const header = useSelector((state) => state.header);
  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージを初期化
    dispatch(clearMessage());
    Auth.currentSession().then(async () => {
      dispatch(setLoading('unit'));
      // プログラムファイルを一覧取得する
      await dispatch(
        await getProgramFiles()
      ).then((result) => {
        // Success
        if (result.status === 200) {
          // 他の画面から渡されたメッセージをセットする
          if (history.location.state && history.location.state.message && history.location.state.message.type && history.location.state.message.msg) {
            const { type, msg } = history.location.state.message;
            history.location.state = null;
            // メッセージをセット
            dispatch(setMessage(type, msg));
            // ヒストリーの初期化
            history.replace({pathname: '/srv/files', state: {}});
          // No Files
          } else if (result.count === 0) {
            dispatch(setMessage('info', msg.update_file.not_found));
          }
        // Error
        } else {
          dispatch(setMessage('danger', error.update_file.gets + `\n${result.errcode}`));
        }
      }).catch((err) => {
        consoleLogger(err);
      });
      dispatch(clearLoading());
    }).catch((err) => {
      consoleLogger(err);
      dispatch(setMessage('danger', error.update_file.gets));
    });
  },[header.mail]);

  React.useEffect(() => {
    setOptions(() => {
      const fileNameList = [];
      const radioButtons = [options.radio_buttons[0]];
      for (const key in filesState.items) {
        const tmpRes = filesState.items[key].key.split('_');
        if (tmpRes.length === 2) {
          const filename = tmpRes[0];
          fileNameList[filename] = {id: filename.toLowerCase(), value: filename, label: filename, defaultChecked: false}; 
        }
      }
      for (const key in fileNameList) {
        radioButtons.push(fileNameList[key]);
        // All以外にチェックされていた場合、チェックを解除する
        const elem = document.getElementById(fileNameList[key].id);
        if (elem && elem.checked) {
          elem.checked = false;
        }
      }
      // Allボタンにチェック
      const element = document.getElementById('all');
      if (element) {
        element.checked = true;
      }
      return {
        ...options,
        radio_buttons: [
          ...radioButtons,
        ]
      };
    });
  }, [filesState]);

  // オプション設定
  const [ options, setOptions ] = React.useState({
    sort: true,            // ソート機能を有効にする
    sort_key: 'key',       // 初期表示で昇順にソートするキーを指定
    filter: true,          // 絞り込み機能オン
    filter_column: 'key',  // 絞り込みカラム
    radio_buttons: [       // 絞り込みラジオボタンを定義
      {id: 'all',      value: 'All',      label: 'All', defaultChecked: true},
    ]
  });
  // テーブルヘッダー定義
  const headers = { items: [], operations: {name: 'Edit', total: 1} }; //操作カラム数=1
  headers.items = [
    { attribute: {}, sort: { key: 'key', isAsc: true }, name: 'File name'},
    { attribute: {}, sort: { key: 'size' }, name: 'Size'},
    { attribute: {}, sort: { key: 'lastModified' }, name: 'Last update'},
  ]; 
  return <SortTable headers={headers} state={filesState} options={options} component={File} /> ;
};
export default FileList;
